import { actionCreatorFactory } from 'typescript-fsa';
import { IGridDataHandlers, IListResponseCounters } from '@cbridge-utils/datagrid';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IMarkupProfile } from '@cbridge-packages/markup-profile';
import { IMarkup, IMarkupDetails, IMarkupListKey, IMarkupSymbolKey } from './markup.interface';

export namespace MarkupAction {
  const actionCreator = actionCreatorFactory('Markup');

  interface IMarkupUpdateParams {
    profileId: IMarkupProfile['markupProfileId'];
    markup: IMarkupDetails;
  }

  export const load = actionCreator.async<IMarkupSymbolKey, IMarkupDetails, IApiErrorParams>('LOAD');
  export const update = actionCreator.async<IMarkupUpdateParams, void, IApiErrorParams>('UPDATE');

  export const loadList = actionCreator.async<IMarkupListKey & IGridDataHandlers, IListResponseCounters, IApiErrorParams>('LOAD_LIST');
  export const exportFile = actionCreator.async<IMarkupListKey, IMarkup[], IApiErrorParams>('EXPORT_FILE');

  export interface IBulkUpdateMarkups {
    profileId: IMarkupProfile['markupProfileId'];
    coreSymbolIds: IMarkup['symbolId'][];
    bidMarkup?: number;
    askMarkup?: number;
    spreadProfileId?: number | null;
  }
  export const bulkUpdate = actionCreator.async<IBulkUpdateMarkups, void, IApiErrorParams>('BULK_UPDATE');

  export interface IBulkRemoveMarkups {
    profileId: IMarkupProfile['markupProfileId'];
    coreSymbolIds: IMarkup['symbolId'][];
  }
  export const bulkRemove = actionCreator.async<IBulkRemoveMarkups, void, IApiErrorParams>('BULK_REMOVE');

  export const destroy = actionCreator('DESTROY');
}
